import { FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { Exoneration } from '../../../../types/foods/Food';

export interface ExonerationFormValues extends Exoneration {
  check?: boolean;
}

export const initialValues: ExonerationFormValues = {
  documentType: '',
  documentNumber: '',
  institutionName: '',
  emitterDate: '',
  percentageExoneration: 0,
  amountExoneration: 0,
  check: false,
};

export const validationSchema: Yup.SchemaOf<ExonerationFormValues> =
  Yup.object().shape({
    documentType: Yup.string().required('Este campo es requerido'),
    documentNumber: Yup.string()
      .required('El número de documento es requerido')
      .matches(/^AL-\d{8}-\d{2}$/, 'El formato debe ser AL-00000000-00'),
    institutionName: Yup.string().required('Este campo es requerido'),
    emitterDate: Yup.string().required('Este campo es requerido'),
    percentageExoneration: Yup.number()
      .typeError('Debe ser un número, separado por puntos. Ej: 0.0')
      .test(
        'Evaluando iva',
        'El porcentaje de iva debe estar entre 1 y 13%',
        (iva) => (iva < 1 || iva > 13 ? false : true)
      )
      .required('Este campo es requerido'),
    amountExoneration: Yup.number()
      .typeError('Debe ser un número, separado por puntos. Ej: 0.0')
      .test('Validacion de totalPrice', 'Debe ser mayor o igual a 0', (value) =>
        value < 0 ? false : true
      )
      .required('Este campo es requerido'),
    check: Yup.bool().notRequired().nullable(),
  });

export interface ExonerationFormProps {
  formikInstance: FormikHelpers<ExonerationFormValues>;
}
